import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import { combineReducers } from "redux";

import adopt from "./adopt/reducer";
import auth from "./auth/reducer";
import roles from "./roles/reducer";
import industry from "./industry/reducer";
import mandays from "./mandays/reducer";
import users from "./users/reducer";
import tenants from "./tenants/reducer";
import menu from "./menu/reducer";
import purchase from "./purchase/reducer";
import myplans from "./myplans/reducer";
import templates from "./templates/reducer";
import generateForm from "./generate_form/reducer";
import helpStore from "./helpStore/reducer";
import notificationStore from "./notification/reducer";
import configuration from "./configuration/reducer";
import pricePlan from "./pricePlan/reducer";
import invoice from "./invoice/reducer";
import tokenPlans from "./tokenPlans/reducer";
import kycSession from "./kyc_session/reducer";
import kyc from "./kyc/reducer";
import kycRenewal from "./kyc-renewal/reducer";
import { loaReducer as loa } from "@repo/redux/loa";
import { netPulseReducer as netPulse } from "@repo/redux/net-pulse";
import useCase from "./use-case/reducer";

import { createBrowserHistory } from "history";

import profile_manager from "./profile_manager/reducer";
import team from "./profile_manager/team/reducer";
import tokenManagement from "./tokenManagement/reducer";
import sku2 from "./sku2/reducer";
import mandays2 from "./mandaysNew/reducer";
import quote from "./quote/reducer";
import dashboardMessager from "./dashboard-message-controller/reducer";
import workspan from "./workspan/reducer";
import opportunities from "./new-opportunity/reducer";
import { activeDealsReducer as activeDeals } from "@repo/redux";
import manDays from "./man-days/reducer";
import dealConfigs from "./deal-configs/reducer";
import iSightCustomers from "./isight-customers/reducer";
import { siteInABoxReducer as siteInABox } from "./site-in-a-box";
export const history = createBrowserHistory();

// Combine reducers
const rootReducer = combineReducers({
  auth,
  roles,
  industry,
  mandays,
  users,
  tenants,
  menu,
  adopt,
  purchase,
  myplans,
  templates,
  generateForm,
  helpStore,
  notificationStore,
  profile_manager,
  team,
  configuration,
  pricePlan,
  tokenManagement,
  invoice,
  tokenPlans,
  kycSession,
  kyc,
  kycRenewal,
  loa,
  netPulse,
  useCase,
  sku2,
  mandays2,
  quote,
  dashboardMessager,
  workspan,
  opportunities,
  activeDeals,
  dealConfigs,
  manDays,
  iSightCustomers,
  siteInABox,
});

// Configure store
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      // Disable immutable check for performance optimization
      serializableCheck: false, // Disable serializable check for performance optimization
    }).concat(
      process.env.NODE_ENV === "development" ? createLogger() : [], // Enable logger in development mode
    ),
});

export default store;
